function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import "jquery.cookie";
import * as React from "react";
import * as ReactDOM from "react-dom";
import * as Api from "../ajax/SalesApi";
import moment from 'moment';
import IntlMessage from '../commons/Intl';
import { Label, Action, Errors, Sales } from '../commons/IntlMessages';
var defaultLanguage = 'ja';
var intl = new IntlMessage(defaultLanguage);
var language = window.navigator.language.substring(0, 2) === 'ja' ? 'ja' : 'en';
intl.setLanguage(language);
/**
 * メインコンポーネント
 */

var MainComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(MainComponent, _React$Component);

  var _super = _createSuper(MainComponent);

  /**
   * フィールド変数の初期化を行います。
   *
   * @param props プロップス
   */
  function MainComponent(props) {
    var _this;

    _classCallCheck(this, MainComponent);

    _this = _super.call(this, props);
    _this.state = {
      TargetYear: String(moment().year()),
      SalesList: []
    };

    _this.onSearch();

    return _this;
  }
  /**
   * 検索結果をクリア後、検索を行います。
   */


  _createClass(MainComponent, [{
    key: "onSearchWithClear",
    value: function onSearchWithClear() {
      var _this2 = this;

      this.setState({
        SalesList: []
      }, function () {
        _this2.onSearch();
      });
    }
    /**
     * 検索を行います。
     */

  }, {
    key: "onSearch",
    value: function onSearch() {
      var _this3 = this;

      Api.GetSales(Number(this.state.TargetYear), function (data) {
        _this3.setState({
          SalesList: data.SalesList
        });
      });
    }
    /**
     * クリアを行います。
     */

  }, {
    key: "onClear",
    value: function onClear() {
      var _this4 = this;

      this.setState({
        TargetYear: String(moment().year()),
        SalesList: []
      }, function () {
        _this4.onSearch();
      });
    }
    /**
     * 対象年を更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateTargetYear",
    value: function updateTargetYear(e) {
      this.setState({
        TargetYear: e.target.value
      });
    }
    /**
     * ComponentがDOMツリーに追加された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.common.bind();
    }
    /**
     * ComponentがDOMツリーから削除された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {}
    /**
     * レンダラー
     */

  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      return /*#__PURE__*/React.createElement("div", {
        className: "content-container"
      }, /*#__PURE__*/React.createElement("div", {
        id: "overlay"
      }, /*#__PURE__*/React.createElement("div", {
        className: "cv-spinner"
      }, /*#__PURE__*/React.createElement("span", {
        className: "spinner"
      }))), /*#__PURE__*/React.createElement("main", {
        className: "main newdesign"
      }, /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: "Action",
        id: "Action",
        value: ""
      }), /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: "StartDate",
        id: "StartDate",
        value: ""
      }), /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: "EndDate",
        id: "EndDate",
        value: ""
      }), /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: "IncludeDeleted",
        id: "IncludeDeleted",
        value: ""
      }), /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: "IncludeSuspended",
        id: "IncludeSuspended",
        value: ""
      }), /*#__PURE__*/React.createElement("div", {
        className: "main__wrapper"
      }, /*#__PURE__*/React.createElement("div", {
        className: "menu",
        id: "menuCont"
      }, /*#__PURE__*/React.createElement("div", {
        className: "menu__title"
      }, intl.format(Sales.Title)), /*#__PURE__*/React.createElement("div", {
        className: "menu__wrapper"
      }, /*#__PURE__*/React.createElement("div", {
        className: "year"
      }, /*#__PURE__*/React.createElement("label", {
        className: "year__title",
        htmlFor: "TargetYear"
      }, intl.format(Label.Period)), /*#__PURE__*/React.createElement("div", {
        className: "year__cotnent"
      }, language == "en" && /*#__PURE__*/React.createElement("label", {
        className: "year__suffix"
      }, intl.format(Sales.YearsCounterSuffix)), /*#__PURE__*/React.createElement("input", {
        id: "TargetYear",
        name: "TargetYear",
        type: "text",
        className: "year__input",
        maxLength: 4,
        onChange: function onChange(e) {
          return _this5.updateTargetYear(e);
        },
        value: this.state.TargetYear,
        tabIndex: 101,
        "data-val": "true",
        "data-val-nowhitespace": intl.format(Errors.InputRequired),
        "data-val-datetime": intl.format(Errors.InputDate),
        "data-val-datetime-format": "YYYY",
        placeholder: "YYYY"
      }), language == "ja" && /*#__PURE__*/React.createElement("label", {
        className: "year__suffix"
      }, intl.format(Sales.YearsCounterSuffix))), /*#__PURE__*/React.createElement("span", {
        className: "text-danger year__danger",
        "data-valmsg-for": "TargetYear",
        "data-valmsg-replace": "true",
        style: {
          fontSize: "16px"
        }
      })), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "menu__btn imgAndTextBtn",
        onClick: this.onSearchWithClear.bind(this)
      }, /*#__PURE__*/React.createElement("div", {
        className: "menu__btnImg imgAndTextBtn__btnImg"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_Search.svg"
      })), /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnText"
      }, intl.format(Action.ConditionSearch))), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "menu__btn menu__btn--white imgAndTextBtn",
        onClick: this.onClear.bind(this)
      }, /*#__PURE__*/React.createElement("div", {
        className: "menu__btnImg imgAndTextBtn__btnImg"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_Cancel.svg"
      })), /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnText"
      }, intl.format(Action.Clear))))), /*#__PURE__*/React.createElement("div", {
        className: "mainContent"
      }, /*#__PURE__*/React.createElement("div", {
        id: "sales",
        className: "table-responsive"
      }, /*#__PURE__*/React.createElement("table", {
        className: "table table-sm table-hover table-striped"
      }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, intl.format(Sales.OrganizationName)), /*#__PURE__*/React.createElement("td", {
        className: "text-right"
      }, intl.format(Sales.Month04)), /*#__PURE__*/React.createElement("td", {
        className: "text-right"
      }, intl.format(Sales.Month05)), /*#__PURE__*/React.createElement("td", {
        className: "text-right"
      }, intl.format(Sales.Month06)), /*#__PURE__*/React.createElement("td", {
        className: "text-right"
      }, intl.format(Sales.Month07)), /*#__PURE__*/React.createElement("td", {
        className: "text-right"
      }, intl.format(Sales.Month08)), /*#__PURE__*/React.createElement("td", {
        className: "text-right"
      }, intl.format(Sales.Month09)), /*#__PURE__*/React.createElement("td", {
        className: "text-right"
      }, intl.format(Sales.Month10)), /*#__PURE__*/React.createElement("td", {
        className: "text-right"
      }, intl.format(Sales.Month11)), /*#__PURE__*/React.createElement("td", {
        className: "text-right"
      }, intl.format(Sales.Month12)), /*#__PURE__*/React.createElement("td", {
        className: "text-right"
      }, intl.format(Sales.Month01)), /*#__PURE__*/React.createElement("td", {
        className: "text-right"
      }, intl.format(Sales.Month02)), /*#__PURE__*/React.createElement("td", {
        className: "text-right"
      }, intl.format(Sales.Month03)), /*#__PURE__*/React.createElement("td", {
        className: "text-right"
      }, intl.format(Sales.Total)))), /*#__PURE__*/React.createElement("tbody", null, this.state.SalesList.map(function (x) {
        return /*#__PURE__*/React.createElement("tr", {
          key: x.OrganizationId
        }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", null, x.OrganizationName)), /*#__PURE__*/React.createElement("td", {
          className: "text-right"
        }, x.Month04 > 0 && x.Month04.toLocaleString()), /*#__PURE__*/React.createElement("td", {
          className: "text-right"
        }, x.Month05 > 0 && x.Month05.toLocaleString()), /*#__PURE__*/React.createElement("td", {
          className: "text-right"
        }, x.Month06 > 0 && x.Month06.toLocaleString()), /*#__PURE__*/React.createElement("td", {
          className: "text-right"
        }, x.Month07 > 0 && x.Month07.toLocaleString()), /*#__PURE__*/React.createElement("td", {
          className: "text-right"
        }, x.Month08 > 0 && x.Month08.toLocaleString()), /*#__PURE__*/React.createElement("td", {
          className: "text-right"
        }, x.Month09 > 0 && x.Month09.toLocaleString()), /*#__PURE__*/React.createElement("td", {
          className: "text-right"
        }, x.Month10 > 0 && x.Month10.toLocaleString()), /*#__PURE__*/React.createElement("td", {
          className: "text-right"
        }, x.Month11 > 0 && x.Month11.toLocaleString()), /*#__PURE__*/React.createElement("td", {
          className: "text-right"
        }, x.Month12 > 0 && x.Month12.toLocaleString()), /*#__PURE__*/React.createElement("td", {
          className: "text-right"
        }, x.Month01 > 0 && x.Month01.toLocaleString()), /*#__PURE__*/React.createElement("td", {
          className: "text-right"
        }, x.Month02 > 0 && x.Month02.toLocaleString()), /*#__PURE__*/React.createElement("td", {
          className: "text-right"
        }, x.Month03 > 0 && x.Month03.toLocaleString()), /*#__PURE__*/React.createElement("td", {
          className: "text-right"
        }, x.Total > 0 && x.Total.toLocaleString()));
      }))))))));
    }
  }]);

  return MainComponent;
}(React.Component);
/**
 * レンダラー
 *
 * @param el バインド対象
 * @param common 共通
 */


export default function (el, common) {
  ReactDOM.render( /*#__PURE__*/React.createElement(MainComponent, {
    common: common
  }), el);
}